export enum AlertOperator {
  EQUAL = 'EQUAL',

  GREATER_THAN = 'GREATER_THAN',

  LESS_THAN = 'LESS_THAN',

  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',

  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',

  IN_RANGE = 'IN_RANGE',

  CHANGED = 'CHANGED',
}
